import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as stakeholder from '../stakeholder'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: stakeholder.RESOURCE.payload.dimension.partialId,
      partialId: stakeholder.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    default: false,
    description: 'Whether this stakeholder is a member of the project team.',
    isOptional: true,
    name: 'Is Project Team Member?',
    partialId: PartialId.Standard.create('is_project_team_member'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
